import type { IPerson } from '../model/IPerson'

export function getPersonName(person: IPerson | null | undefined): string {
	return person == null
		? 'Ismeretlen személy'
		: [person.honorific, person.lastName, person.firstName]
				.filter(Boolean)
				.join(' ')
}
